import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Text,
  LegacyCard as Card,
  Checkbox,
  Select,
  InlineStack,
  BlockStack,
  TextField,
} from "@shopify/polaris";
import { useMutation } from "@apollo/client";

// import Helper
import { baseHelper, errorHelper } from "lib/helpers";

// import constant
import constant from "lib/constant/constant";

// import component
import { Banner, Sheet, Toast } from "lib/components";

// import mutations
import { UPDATE_PRODUCT_LAKE_FULFILLMENT } from "app/productLake/apollo/mutations";

// import prop Type
import { tabProp } from "app/product/modules/generic/propTypes";

// import context
import { PrivateContext } from "lib/context/privateContext";
import { ProductContext } from "app/productLake/modules/generic/context";
import { withErrorBoundary } from "lib/hoc";
import { useNavigate, useParams } from "react-router-dom";

const { SELECT_WEIGHT = "" } = constant;

const Fulfillment = (props) => {
  const { tabObj = {} } = props;
  const { islastTab = false } = tabObj || {};
  const {
    handleTabChange,
    isVariable,
    isVariant,
    setBanner,
    setDescription,
    setTitle,
    productValue,
    refetchProduct,
  } = useContext(ProductContext);
  const [value, setValue] = useState(productValue);
  const { cms, currentUser } = useContext(PrivateContext);
  const navigate = useNavigate();
  const { id } = useParams();
  const { isAttachmentVisible = false } = currentUser || {};
  const { CRITICAL, gql, weightValue } = constant;
  const [loader, setLoader] = useState(false);
  const [message, setMessage] = useState("");
  const [sheetActive, setSheetActive] = useState(false);
  const [disabledButton, setDisabledButton] = useState(true);
  // const [sheetTitle, setSheetTitle] = useState("");
  // const [sheetContent, setSheetContent] = useState("");
  setDescription(cms("label.editFulfillment"));
  setTitle(cms("label.title.fulfillment"));
  const fieldData = [constant.IS_SHIPPING];
  const handleChange = (fieldName, fieldValue) => {
    setValue({
      ...value,
      [fieldName]: (!fieldData.includes(fieldName) && parseFloat(0)) || fieldValue,
    });
  };

  const acceptOnlyValidInput = (val, measurementValue) => {
    return (baseHelper.validatePositiveNumericValues(val) && val) || (val !== "" && measurementValue);
  };

  const [addProductFulfillment, { loading: addFulfillmentLoading }] = useMutation(UPDATE_PRODUCT_LAKE_FULFILLMENT);

  useEffect(() => {
    if (productValue) {
      const { weight } = productValue;
      if (!weight) {
        setValue({
          weight,
        });
      }
      if (weight) {
        setValue({ weight, isShipping: true });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productValue]);

  const isVendor = baseHelper.isVendor(currentUser);

  const primaryAction = {
    content: cms("button.done"),
    onAction: () => setSheetActive(false),
  };

  const secondaryAction = {
    content: cms("common.button.cancel"),
    onAction: () => setSheetActive(false),
  };

  const onFormSubmit = async () => {
    const formValues = {
      productId: id,
      weight: value.isShipping ? parseFloat(value.weight) : 0,
    };

    await addProductFulfillment({ variables: { input: formValues } })
      .then((res) => {
        const responseError = baseHelper.getResponseError(res.data, gql.UPDATE_PRODUCT_LAKE_FULFILLMENT);
        const responseData = baseHelper.getResponseData(res.data, gql.UPDATE_PRODUCT_LAKE_FULFILLMENT);
        if (responseError) {
          setBanner({ isOpen: true, status: CRITICAL, title: responseError });
        }
        if (responseData) {
          setLoader(false);
          setMessage(cms("message.success.fulfillment"));
          setBanner({ isOpen: false, status: "", title: "" });
          refetchProduct();
          setTimeout(() => {
            if (islastTab) {
              navigate("/product-lake");
              return;
            }
            handleTabChange(5);
          }, 1500);
        }
      })
      .catch((exception) => {
        setBanner({ isOpen: true, status: CRITICAL, title: errorHelper.parse(exception) });
      });
  };
  const selectWeight = (
    <Select
      id="weightUnit"
      value={weightValue.KG}
      label={cms("label.unit")}
      onChange={(val) => {
        handleChange(SELECT_WEIGHT, val);
        setDisabledButton(false);
      }}
      placeholder={cms("placeholder.unit")}
      labelHidden
      options={[weightValue.KG]}
    />
  );

  const isNew = value && value.status && value.status.toLowerCase() === constant.NEW;

  return (
    <>
      <Card
        title={[
          cms("label.shipping"),
          value && value.title && (
            <Text as="span" tone="subdued">
              {value.updatedAt && (
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(value.updatedAt)}`}</Text>
              )}
            </Text>
          ),
        ]}
        id="productshipping"
        // actions={[
        //   {
        //     content: cms("label.more"),
        //     onAction: () => {
        //       learnMore("productshipping", cms("label.shipping"));
        //     },
        //   },
        // ]}
      >
        <Card.Section>
          <BlockStack gap="2">{cms("label.caption.weight")}</BlockStack>
          <br />
          <Checkbox
            id="shippingCheckbox"
            label={isVendor ? `${cms("label.physical")}` : cms("label.physical")}
            checked={value.isShipping || ""}
            onChange={(val) => {
              handleChange(constant.IS_SHIPPING, val);
              setDisabledButton(false);
            }}
          />
          {!value.isShipping && (
            <div>
              <br />
              <Banner isOpen status={constant.INFO} isScrollTop={false}>
                <p>{cms("label.uncheck")}</p>
              </Banner>
            </div>
          )}
        </Card.Section>
        {value.isShipping && (
          <Card.Section title={cms("label.weight")}>
            <p>{cms("label.caption.rate")}</p>
            <br />
            <TextField
              id="weight"
              label={cms("label.weight")}
              value={(value.weight && value.weight.toString()) || ""}
              placeholder={constant.ZERO_PRICE}
              onChange={(val) => {
                handleChange(constant.WEIGHT, acceptOnlyValidInput(val, value.weight));
                setDisabledButton(false);
              }}
              connectedRight={selectWeight}
            />
            <br />
          </Card.Section>
        )}
      </Card>
      <div className="toast">
        <Toast message={message} />
      </div>
      <br />
      <InlineStack>
        <Button onClick={() => (isVariable && !isVariant ? handleTabChange(3) : handleTabChange(2))}>
          {cms("common.button.previous")}
        </Button>
        {isNew && isAttachmentVisible && (
          <Button onClick={() => handleTabChange(5)} disabled={addFulfillmentLoading}>
            {/* {isAttachmentVisible ? "Skip" : "Finish"} */}
            {cms("common.button.skip")}
          </Button>
        )}
        <Button
          variant="primary"
          onClick={() => onFormSubmit()}
          disabled={islastTab ? false : disabledButton}
          loading={loader || addFulfillmentLoading}
        >
          {!isAttachmentVisible ? cms("common.button.finish") : cms(`common.button.${islastTab ? "submit" : "save"}`)}
        </Button>
      </InlineStack>
      {/* <PageActions
        primaryAction={{
          content: cms(`button.${islastTab ? "submit" : "save"}`),
          onAction: () => onFormSubmit(),
          loading: loader || addFulfillmentLoading,
          disabled: disabledButton,
        }}
        secondaryActions={[
          {
            content: cms("button.previous"),
            onAction: () => handleTabChange(3),
          },
        ]}
      /> */}
      <Sheet
        // title={sheetTitle}
        isOpen={sheetActive}
        onClose={() => setSheetActive(false)}
        primaryAction={primaryAction}
        secondaryAction={secondaryAction}
      >
        {/* {sheetContent} */}
      </Sheet>
    </>
  );
};

Fulfillment.propTypes = tabProp.type;

export default withErrorBoundary(Fulfillment);
